import React from "react";
import { motion } from "framer-motion";
import { FaTrophy, FaRocket, FaBullseye, FaWhatsapp, FaGamepad } from "react-icons/fa";
import BackButton from "./BackButton";
import "./about.css";

const About = () => {
  return (
    <div className="about-container dark-theme">
      <nav className="about-nav">
        <BackButton />
      </nav>

      {/* Heading */}
      <motion.div 
        className="about-header"
        initial={{ opacity: 0, y: -50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8 }}
      >
        <FaGamepad className="header-icon" />
        <h1 className="about-title">About AUBattle</h1>
        <p className="about-subtitle">Your Gateway to Competitive Gaming</p>
      </motion.div>

      {/* Introduction Section */}
      <motion.div 
        className="intro-card"
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        <p className="intro-text">
          Welcome to <span className="highlight">AUBattle</span>, your ultimate destination for competitive gaming! 
          Our platform brings gamers together, providing thrilling e-sports experiences 
          across various games. Whether you're a casual player or a seasoned pro, AUBattle 
          offers an inclusive environment to compete, connect, and enjoy gaming.
        </p>
      </motion.div>

      {/* Sections with Hover Effects */}
      <div className="about-sections">
        <motion.div 
          className="about-card"
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="card-header">
            <FaBullseye className="card-icon" />
            <h2>Our Mission</h2>
          </div>
          <div className="card-content">
            <p>
              At <span className="highlight">AUBattle</span>, we create opportunities for gamers to 
              showcase skills, earn rewards, and build a vibrant community. 
              We make e-sports accessible through free and affordable tournaments.
            </p>
          </div>
        </motion.div>

        <motion.div 
          className="about-card"
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="card-header">
            <FaTrophy className="card-icon" />
            <h2>What We Offer</h2>
          </div>
          <div className="card-content">
            <ul className="features-list">
              <li><span className="highlight">Diverse Tournaments:</span> For all skill levels</li>
              <li><span className="highlight">Community:</span> Connect with fellow gamers</li>
              <li><span className="highlight">Rewards:</span> Cash prizes and exclusive merch</li>
              <li><span className="highlight">User Experience:</span> Easy tournament management</li>
            </ul>
          </div>
        </motion.div>

        <motion.div 
          className="about-card"
          whileHover={{ y: -5 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="card-header">
            <FaRocket className="card-icon" />
            <h2>Join Us</h2>
          </div>
          <div className="card-content">
            <p>
              Whether to compete, spectate, or engage with the community, 
              AUBattle is your e-sports platform. <span className="highlight">Join Our Channel </span> 
              and join our network of passionate gamers.
            </p>
           <a href="https://whatsapp.com/channel/0029Vb5yksE11ulTUSnpYO1m" target="_blank" rel="noopener noreferrer">
  <button className="cta-button">
    Join Channel <FaWhatsapp className="cta-icon" />
  </button>
</a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;